import { Component, ErrorInfo, ReactNode } from "react";
import logoEgam from "../../assets/images/logo-egam-login.png";
import {
  Container,
  Card,
  Logo,
  Title,
  Subtitle,
  Button,
  SecondaryButton,
  Divider,
  ButtonsContainer,
  Details,
} from "./styles";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null,
    };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary capturou um erro:", error, errorInfo);

    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  override render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <Container>
          <Card>
            <Logo src={logoEgam} alt="eGAM" />

            <Title>Ocorreu um erro inesperado</Title>

            <Divider />

            <Subtitle>
              Algo deu errado ao carregar esta página. Por favor, tente
              novamente ou volte para a página inicial.
            </Subtitle>

            <ButtonsContainer>
              <Button onClick={this.handleReset}>Tentar novamente</Button>
              <SecondaryButton onClick={() => (window.location.href = "/")}>
                Ir para página inicial
              </SecondaryButton>
            </ButtonsContainer>

            {process.env["NODE_ENV"] === "development" && this.state.error && (
              <Details>
                <summary>Detalhes do erro (apenas em desenvolvimento)</summary>
                <pre>
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </Details>
            )}
          </Card>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
